const Big = require('big.js');

class NumberToFix {
  constructor(originalOrder, value, weight) {
    this.originalOrder = originalOrder;
    this.value = value;
    this.weight = weight;
  }

  increment(value) {
    this.value = this.value.plus(value);
  }

  decrement(value) {
    this.value = this.value.minus(value);
  }
}
function getIncrement(decimalPlaces) {
  return Big(1).div(Big(10).pow(decimalPlaces));
}
/**
 * Função que distribui uma determinada amostra entre as porcentagens passadas
 * por parametro.
 *
 * O arredondamento das cotas numéricas funcionam da seguinte forma:
 * o valor é calculado para cada porcentagem e truncado, ao final é visto
 * se sobrou ou faltou cota numerica, caso tenha faltado, 1 unidade é acrescida para cada
 * cota até atingir o valor esperado. Caso contrário, o mesmo será feito porém desta vez
 * será decrecida 1 unidade de cada cota até atingir o valor esperado.
 *
 * O acrescimo de cota valor é feito do maior para o menor;
 * O decremento é feito do menor para o maior;
 *
 * @param total Amostras a serem distribuidas
 * @param numbers Array contendo as cotas percentuais a serem distribuidas
 */
export default function largestRemainder(
  total, // no evolutivo, definido como percentual = 100 FIXME: por que??
  numbers,
  decimalPlaces, // no evolutivo, definido como zero
) {
  // acceptable diff
  const epsilon = 5; // ~0.05
  // validar o array de entrada
  if (!Array.isArray(numbers) || numbers.length === 0) {
    return [];
  }
  // somando os números
  const numbersSum = numbers.reduce((a, b) => a + b);
  // definindo o valor total aceitável
  let newNumbers = numbers;
  if (numbersSum < (total - epsilon)) {
    newNumbers = numbers.map((n) => ((n * 100.00) / numbersSum));
  }
  // convertendo para big
  const bigTotal = Big(total);
  // convertendo os números em bignumber
  const bigNumbers = newNumbers.map((num) => Big(num));
  // definindo a quantidade de números no array
  const size = bigNumbers.length;
  // arredonda os números
  const roundedNumbers = bigNumbers.map((bigNum) => bigNum.round(decimalPlaces, 0));
  // calcula a soma dos números
  const roundedSum = roundedNumbers.reduce((reduced, next) => reduced.plus(next));
  // verifica se o total é maior que a soma
  const shouldIncrease = bigTotal.gt(roundedSum);
  const desc = shouldIncrease;
  // sempre 1 FIXME: por que???
  const incrementor = getIncrement(decimalPlaces);
  // idenxando números
  const indexedNumbers = bigNumbers
    .map((current, index) => {
      const remainder = current.mod(Big(1).div(Math.pow(10, decimalPlaces)));
      const rounded = current.round(decimalPlaces, 0);
      return new NumberToFix(index, rounded, remainder);
    })
    .sort((prev, next) => {
      if (desc) {
        const weightCompareDiff = next.weight.cmp(prev.weight);
        const comparingValue = weightCompareDiff === 0 ? next.value.cmp(prev.value) : weightCompareDiff;

        return comparingValue;
      }
      const weightCompareDiff = prev.weight.cmp(next.weight);
      const comparingValue = weightCompareDiff === 0 ? prev.value.cmp(next.value) : weightCompareDiff;
      return comparingValue;
    });

  const iterationTimes = Number(
    bigTotal.sub(roundedSum).abs().times(Math.pow(10, decimalPlaces)).toString(),
  );

  for (let i = 0; i < iterationTimes; i += 1) {
    const current = indexedNumbers[i % size];
    if (shouldIncrease) {
      current.increment(incrementor);
    } else {
      current.decrement(incrementor);
    }
    indexedNumbers[i % size] = current;
  }

  return indexedNumbers
    .sort((n1, n2) => n1.originalOrder - n2.originalOrder)
    .map((n) => Number(n.value.toString()));
}
